export default __webpack_public_path__ + "static/media/Dappcraft_C01.91c7efa6.mp4";